/**
 * Inline Traeva brand wordmark — for use inside headings and body copy.
 * Renders as a span (not a link). Inherits font-size from parent.
 *
 * Split: "Trae" + "va" + dot
 * Light variant: Trae ink   · va navy-mid · coral dot
 * Dark  variant: Trae white · va coral    · coral dot
 */
export default function Brand({ variant = "light", className = "" }) {
  const colors = variant === "dark"
    ? { trae: "text-white", va: "text-coral", dot: "bg-coral" }
    : { trae: "text-ink",   va: "text-navy-mid", dot: "bg-coral" };

  return (
    <span className={`font-serif-i italic whitespace-nowrap inline-flex items-start leading-none ${className}`}>
      <span className={colors.trae}>Trae</span>
      <span className={colors.va}>va</span>
      <span
        aria-hidden="true"
        className={`ml-[0.12em] mt-[0.18em] w-[0.18em] h-[0.18em] rounded-full inline-block shrink-0 ${colors.dot}`}
      />
    </span>
  );
}
